import { useHandleDateTime } from "./utils/hooks/useHandleDateTime";
import useRouterEvents from "./utils/hooks/useRouterEvenets";

const useV3Middleware = () => {
  useRouterEvents();
  const { clock, onFinish } = useHandleDateTime();

  return { onFinish: onFinish, clock };
};

export default useV3Middleware;
